/**
 * Vanilla Next (vn) API
 *
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */


export interface CatalogAddressRowModel { 
    rowId: number;
    slug: string;
    compositeProductId: number;
    countryId: number;
}

